import { render, staticRenderFns } from "./MotivoAgregacaoList.vue?vue&type=template&id=48bedc99"
import script from "./MotivoAgregacaoList.vue?vue&type=script&lang=js"
export * from "./MotivoAgregacaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports